export var SkuMappingStatus;
(function (SkuMappingStatus) {
    SkuMappingStatus["APPROVED"] = "approved";
    SkuMappingStatus["DRAFT"] = "draft";
})(SkuMappingStatus || (SkuMappingStatus = {}));
//# sourceMappingURL=sku-mapping-status.js.map